export const Menuitems =[
    {
title: "Home",
url: "#",
cName: "nav-links"
},
{
    title: "Products",
    url: "#",
    cName: "nav-links"
    },
    {
        title: "Sales",
        url: "#",
        cName: "nav-links"
        },
        {
            title: "Coustmers",
            url: "#",
            cName: "nav-links"
            },
            {
                title: "Holds",
                url: "#",
                cName: "nav-links"
                },
            
]